
import React from "react";
import { currencyFormat } from "../utils";
import Text from "./Text";

const FormattedPrice = ({
  price,
  negative = "",
  align = "left",
  suffix = "",
  textColor,
  fontFamily,
  ...restProps

}) => {
  return (
    <Text align={align} testId="formatted-price" {...restProps} color={textColor} fontFamily={fontFamily}>
      {!isNaN(price) ? `${negative && "-"} $${currencyFormat(price)}` : "$0.00"}
      {suffix}
    </Text>
  );
};

export default FormattedPrice;
